<template>
  <router-link :to="characterURL" class="character-list-item">
    {{name}}
    <span class="handle">
      <svg width="25" height="25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21.198 10.581h-18M21.198 6.581h-18M21.198 14.581h-18M21.198 18.581h-18"
         stroke="#231F1C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>
  </router-link>
</template>

<script>
export default {
  name: 'CharacterListItem',
  props: {
    id: String,
    url: String,
    name: String,
  },
  computed: {
    characterURL() {
      return {
        name: 'EditCharacter',
        params: {
          id: this.id,
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.character-list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;
  padding: 10px 15px;
  background: rgb(247, 240, 234);
  border-radius: var(--radius);
  color: var(--color-dark);
  &:hover {
    color: var(--color-link);
  }
  span {
    display: inline-flex;
    cursor: grab;
    opacity: 0.5;
    &:hover {
      opacity: 1;
    }
  }
}
</style>
